export class SetErrorAction {
  public static readonly type = '[Project/Storage/List] SetErrorAction';
  constructor(public readonly error: Error) {}
}
